import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { getImage } from '@utils/imageHelper';
import { Spacings } from '@styles/index';
import { pluralize } from '@utils/textHelper';
import {
  UpcomingCourses,
  EnrolledCourses,
  CoursesInfo
} from '../TopicCardElements';
import { windowMap, hasWindowInfoText } from './topicCardUtils';

const WindowImage = styled.img`
  margin-right: ${Spacings.SPACING_6};
  flex: 0 0 auto;
`;

const windowLabelMap = {
  [windowMap.TODAY]: 'today',
  [windowMap.TOMORROW]: 'tomorrow',
  [windowMap.THIS_WEEK]: 'this week',
  [windowMap.IN_15_DAYS]: 'in 15 days',
  [windowMap.YESTERDAY]: 'yesterday',
  [windowMap.LAST_WEEK]: 'last week',
  [windowMap.AGO_15_DAYS]: '15 days ago'
};

const TopicCardInfoText = ({ topic, isSubscribed }) => {
  const { upcomingCoursesCount, enrolledCoursesCount } = topic;
  let renderPrimaryCoursesCount = null;
  const renderSecondaryCoursesCount = '';
  if (!isSubscribed) {
    if (hasWindowInfoText(topic)) {
      renderPrimaryCoursesCount = (
        <>
          <WindowImage src={getImage('window_courses.svg')} size="14px" />
          <UpcomingCourses>
            {`${pluralize(topic.windowCount, 'course')} starting ${
              windowLabelMap[topic.window]
            }`}
          </UpcomingCourses>
        </>
      );
    }
  } else if (enrolledCoursesCount > 0) {
    renderPrimaryCoursesCount = (
      <EnrolledCourses>{`${enrolledCoursesCount} enrolled`}</EnrolledCourses>
    );
  } else if (upcomingCoursesCount > 0) {
    renderPrimaryCoursesCount = `${upcomingCoursesCount} upcoming`;
  }
  return (
    <CoursesInfo>
      {renderPrimaryCoursesCount}
      {renderSecondaryCoursesCount}
    </CoursesInfo>
  );
};

TopicCardInfoText.propTypes = {
  topic: PropTypes.objectOf(PropTypes.any).isRequired,
  isSubscribed: PropTypes.bool.isRequired
};

export default TopicCardInfoText;
